import { useState, useEffect } from 'react';

import { SpinePlayer } from '@esotericsoftware/spine-player';

import { PUBLIC_URL } from '../utils/constants';

export const useAnimation = ({ ref, name, viewport = {}, ...rest }) => {
	const [animation, setAnimation] = useState(null);

	useEffect(() => {
		if (!ref?.current) return;

		const spine = new SpinePlayer(ref?.current, {
			jsonUrl: `${PUBLIC_URL}/static/media/animation/${name}/${name}.json`,
			atlasUrl: `${PUBLIC_URL}/static/media/animation/${name}/${name}.atlas`,
			backgroundColor: '#00000000',
			preserveDrawingBuffer: true,
			alpha: true,
			showControls: false,
			showLoading: false,
			animation: 'idle',
			defaultMix: 0.1,
			viewport,
			...rest,
		});

		setAnimation(spine);

		return () => {
			try {
				spine?.dispose?.();
			} catch (e) {
				console.warn('failed to cleanup spine', e);
			}
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [name, ref?.current]);

	return animation;
};
